import { createAction } from '../util/index.js';


export const clearExceptionList = createAction('CLEAR_EXCEPTION_LIST', { noPayload: true });
export const hideProgress = createAction('HIDE_PROGRESS', { noPayload: true });
export const clearEditLocationList = createAction('CLEAR_EDIT_LOCATION_LIST', { noPayload: true });
export const clearEditSupplierForm = createAction('CLEAR_EDIT_SUPPLIER_FORM', { noPayload: true });
